import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../brochure.scss';
import { actions } from '../redux/brochureActions';
import { bindActionCreators } from 'redux';
import { Box, Loader } from '../../../common/components';
import BrokerSetPasswordForm from '../components/BrokerSetPasswordForm/BrokerSetPasswordForm';

class BrokerSetPasswordContainer extends Component {
  static propTypes = {
    // dispatch: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const {
      actions,
      params: { token },
      broker,
    } = this.props;
    if (!broker) {
      actions.retrieveBroker(token);
    }
  }

  activateBroker = (application) => {
    const {
      params: { token },
      actions,
    } = this.props;
    actions.activateBroker(token, application);
  };

  render() {
    const { broker } = this.props;
    if (!broker) {
      return <Loader />;
    }
    return (
      <Box className={'broker-activation-container'}>
        <BrokerSetPasswordForm
          submitting={false}
          activateBroker={this.activateBroker}
          {...this.props}
        />
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    broker: state.brochure.broker,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(BrokerSetPasswordContainer);
